/// Mirrors `MAX_MAINTENANCE_GUIDE_BYTES` in common_config — a context budget
/// (the guide lands in an agent's context every maintenance session), not a
/// storage limit. The server measures UTF-8 bytes, so this side must too.
export const MAX_GUIDE_BYTES = 10_000;

export const utf8Bytes = (s: string): number =>
  new TextEncoder().encode(s).length;

/// Decimal KB, not the binary `formatBytes`: the 10 000-byte cap must read
/// "10 KB", not "9.8 KB".
export const formatGuideSize = (bytes: number): string =>
  bytes < 1_000
    ? `${bytes} B`
    : `${(bytes / 1_000).toFixed(1).replace(/\.0$/, "")} KB`;

/// ~4 UTF-8 bytes per token — the standard English-prose heuristic for
/// BPE tokenizers. An estimate by nature, hence the "~" wherever shown.
export const approxTokens = (bytes: number): number => Math.ceil(bytes / 4);
